// extracted by mini-css-extract-plugin
export default {"resetButton":"wqprOQj","docType":"_VAEoGF"};